<template>
  <div>
    <FITModal size="lg" :shouldPreventDefault="true" ref="renewLifeModal" reference="modal" :title="$t('osm.renewal.renewLife.header')" @click="onClickModalRenewLife">
      <div slot="body">
        <RenewLifeComponent v-if="selectedLifeDetail" v-model="renewLifeForm" :detail="selectedLifeDetail"></RenewLifeComponent>
        <FITAlert ref="modalErrorAlert" :alertContent="alertContent" :variant="alertParams.variant" :alertSec="3" :dismissible="true"></FITAlert>
      </div>
    </FITModal>
    <FITAlert ref="alert" :alertContent="alertContent" :variant="alertParams.variant" :alertSec="3" :dismissible="true"></FITAlert>
    <FITFormCard>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <h4>{{$t('osm.renewal.quickRenew')}}</h4>
          </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <FITSearchableTable ref="table" vuexModule="Renewal" searchAction="getQuickRenewalList" type="renewal" :columns="columns" :filters="filters" @onRowSelected="onRowSelected"></FITSearchableTable>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">
import Vue from 'vue'
import RenewLife from './RenewLife'
import RenewLifeComponent from '../components/RenewLifeComponent'
import { FITSearchableTable, FITFormCard, FITAlert, FITModal, FITAutoSearch } from '@/components'
import { mapGetters } from 'vuex';
import moment from 'moment';
export default {
  name: 'QuickRenew',
  props:{
    paymentDate:{
      type:String
    },
  },
  created(){
    if(this.paymentDate){
      for (var i = 0; i < this.filters.length; i++) {
        if((this.filters[i].key == "dateFromNextPaymentDate")||(this.filters[i].key == "dateToNextPaymentDate")){
          this.filters[i].default = this.paymentDate;
        }
      }
    }
        // this.$refs.table.search();
  },
  computed: {
    ...mapGetters(['getTranslatedArray']),
    alertContent() {
      switch (this.alertParams.variant) {
        case 'success':
          return `<i class="fas fa-check-circle"></i> ${this.alertParams.content}`;
        case 'danger':
          return `<i class="fas fa-check-circle"></i> ${this.alertParams.content}`;
        default:
          return this.alertParams.content;
      }
    },
  },
  methods: {
    onRowSelected(row) {
      if (this.$store.state.permissionLevel > 3.5) {
        return;
      }
      switch (row.policyType.toUpperCase()) {
        case 'G':
          this.$store.commit({ type: 'GIPolicy/setGIPolicyID', policyID: row.policyID });
          this.$router.push({
            name: 'Create GI Policy',
            params: {
              renewalPolicyID: row.policyID
            }
          });
          break;
        case 'P':
          Vue.set(this, 'selectedLifeDetail', row);
          Vue.set(this.renewLifeForm, 'policyID', row.policyID);
          Vue.set(this.renewLifeForm, 'modalPremium', row.modalPremium);
          Vue.set(this.renewLifeForm, 'period', 1);
          Vue.set(this.renewLifeForm, 'actualPaymentDate', moment().format('YYYY-MM-DD'));
          this.$refs.renewLifeModal.openModal();
          break;
      }
    },
    getTranslated(type, key) {
      if (!key) {
        return 'N/A';
      }
      let result = this.getTranslatedArray(this.$i18n.locale, 'Renewal', type)
        .filter((item) => {
          return item.value === key
        });
      if (result.length > 0) {
        return result[0].text;
      }
      return 'N/A';
    },
    onClickModalRenewLife(event) {
      if (!event) {
        return;
      }
      Vue.set(this.renewLifeForm, 'paymentAmount', this.renewLifeForm.modalPremium);
      Vue.set(this.renewLifeForm, 'paymentDate', this.renewLifeForm.actualPaymentDate);

      this.$store.dispatch('Renewal/renewLife', this.renewLifeForm).then((json) => {
        Vue.set(this, 'alertParams', { 'content': this.$t('general.updateSuccess'), variant: 'success' });
        this.$refs.table.search();
        this.$refs.alert.showAlert();
        this.$refs.renewLifeModal.closeModal();
      }).catch((error) => {
        Vue.set(this, 'alertParams', { 'content': this.$t('general.updateError'), variant: 'danger' });
        this.$refs.modalErrorAlert.showAlert();
        console.debug(error);
      })
    },
  },
  data() {
    return {
      selectedLifeDetail: {},
      renewLifeForm: {
        policyID: 0,
        modalPremium: 0,
        period: 0,
        actualPaymentDate: '',
        policyType: 'P',
        paymentMethod: '',
        paymentReference: '',
        companyBank: '',
        paymentDate: '',
        paymentStartDate: '',
        paymentEndDate: '',
        paymentAmount: 0,
      },
      alertParams: {
        content: '<strong>Success</strong>',
        variant: 'success'
      },
      columns: [{
          key: 'policyNumber',
          label: this.$t('osm.contents.lifePolicy.generalInformation.policyNumber'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.$options.filters.isEmpty(row);
          }
        },
        {
          key: 'productEnglishName',
          label: this.$t('osm.product.productName'),
          sortable: true,
          formatter: (row, key, item) => {
            return item.productEnglishName + "</br>" + item.productChineseName;
          }
        },
        {
          key: 'chineseNameCustomer',
          label: this.$t('osm.contents.lifePolicy.generalInformation.policyOwner'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.$options.filters.isEmpty(item.englishNameCustomer) + "</br>" + this.$options.filters.isEmpty(item.chineseNameCustomer)
          }
        },
        {
          key: 'policyType',
          label: this.$t('osm.renewal.list.policyType'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.getTranslated('policyType', row);
          }
        },
        {
          key: 'nextPaymentDate',
          label: this.$t('osm.renewal.list.nextPaymentDate'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.$options.filters.isEmpty(row)
          }
        },
        {
          key: 'modalPremium',
          label: this.$t('osm.renewal.list.modalPremium'),
          sortable: true,
          formatter: (row, key, item) => {
            if (row != null && parseFloat(row) > 0) return '$ ' + parseFloat(row).toFixed(2);
            return '$ 0'
          }
        }
      ],
      // actions: [{
      //   text: this.$t('osm.renewal.renew'),
      //   key: 'edit',
      //   callback: (key, row, instance) => {
      //     // Vue.set(this, 'clickedRow', row);
      //     this.$router.push({
      //       name: 'Renew Life Policy',
      //       params: { detail: row }
      //     });
      //   }
      // }],
      filters: [{
        label: this.$t('osm.renewal.list.policyType'),
        key: 'policyType',
        type: 'select',
        default: null
      }, {
        label: this.$t('osm.renewal.list.nextPaymentDateFrom'),
        key: 'dateFromNextPaymentDate',
        type: 'datetime',
        default: ''
      }, {
        label: this.$t('osm.renewal.list.nextPaymentDateTo'),
        key: 'dateToNextPaymentDate',
        type: 'datetime',
        default: ''
      }],
    }
  },
  components: {
    FITSearchableTable,
    FITFormCard,
    FITAlert,
    FITModal,
    FITAutoSearch,
    RenewLife,
    RenewLifeComponent
  }
}

</script>



// WEBPACK FOOTER //
// src/Osm/Renewal/containers/QuickRenew.vue